import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import { __Rutas } from "./../../Core/environment";
import HomePage from "./../../Pages/Home/Home.page";
import CatalogoPage from "./../../Pages/Catalogo/Catalogo.page";
import CarritoPage from "./../../Pages/Carrito/Carrito.page";
import NotFoundPage from "./../../Pages/NotFound/NotFound.page";
import HistorialPage from "./../../Pages/Historial/Historial.page";

const PrivateRoute = () => {
  return (
    <Switch>
      <Route exact path={__Rutas.Home} component={HomePage} />
      <Route exact path={__Rutas.Catalogo} component={CatalogoPage} />
      <Route exact path={__Rutas.Carrito} component={CarritoPage} />
      <Route exact path={__Rutas.Historial} component={HistorialPage} />
      <Redirect from={__Rutas.Login} to={__Rutas.Home} />
      <Redirect from={__Rutas.Registro} to={__Rutas.Home} />
      <Route exact strict component={NotFoundPage} />
    </Switch>
  );
};

export default PrivateRoute;
